export { DimmerComponent } from './dimmer.component';
export { L_DimmerModule } from './dimmer.module';
